var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoggedIn)?_c('user-button'):(!_vm.$vuetify.breakpoint.xs)?_c('button',{staticClass:"login-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.goToSignIn()}}},[_vm._v(" "+_vm._s(_vm.$t('nav.signIn'))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }